import { render, staticRenderFns } from "./DRTabsLists.vue?vue&type=template&id=84bb1778&"
import script from "./DRTabsLists.vue?vue&type=script&lang=js&"
export * from "./DRTabsLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports